import classNames from 'classnames';

import { useTimeZonedFunctions } from '/src/hooks';

export function DateDisplay({ className, date, full }) {
  const { formatDay, formatDayFull } = useTimeZonedFunctions();

  if (!date) return null;

  const displayDate = full ? formatDayFull(date) : formatDay(date);

  return <span className={classNames(className)}>{displayDate}</span>;
}
